import { render, staticRenderFns } from "./listWork.vue?vue&type=template&id=528fc770&scoped=true&"
import script from "./listWork.vue?vue&type=script&lang=js&"
export * from "./listWork.vue?vue&type=script&lang=js&"
import style0 from "./listWork.vue?vue&type=style&index=0&id=528fc770&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528fc770",
  null
  
)

export default component.exports